
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as test1gYpOS5lEE8aDLzKFCpuf6ND_45tOoazwhm3EyMvxJqvkMeta } from "/opt/atlassian/pipelines/agent/build/pages/test.vue?macro=true";
import { default as indexeH_45knvsPxuzKCtuhxbzmq3A52gxj9sNHQK_MhXjK724Meta } from "/opt/atlassian/pipelines/agent/build/pages/index.vue?macro=true";
import { default as barcodeoCmY_6macwM57w28uvKpkP3XK6MwE7plf9QCQr_zubIMeta } from "/opt/atlassian/pipelines/agent/build/pages/barcode.vue?macro=true";
import { default as barcodelookupt2wSFq7vdXraB_12xL0KU8UdoBLAkSyPBb7wFuty3FoMeta } from "/opt/atlassian/pipelines/agent/build/pages/barcodelookup.vue?macro=true";
import { default as tailwindfixes9iLDvzW_45zryN68WdUfZpLpe8XJ20r5utsMLdYjxLy9UMeta } from "/opt/atlassian/pipelines/agent/build/pages/tailwindfixes.vue?macro=true";
import { default as searchYbfsW8AmeuBLPQ8W0oyZaeY_Fq5uiMZgT9TBFhH8zqUMeta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/search.vue?macro=true";
import { default as _91_46_46_46slug_93s9dV7W0HCoMclY1pk8hm_MupxaEggIy7hpVL4anbzFoMeta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/[...slug].vue?macro=true";
import { default as formValidationTemplatecmah_45YROUY0wyA3TAfJVi35jseV0J_45adk2557UITYYIMeta } from "/opt/atlassian/pipelines/agent/build/pages/formValidationTemplate.vue?macro=true";
import { default as invite5d27DaMOu2L4n31zbg9HiVITj54eaxYadcMO68d30HYMeta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/invite.vue?macro=true";
import { default as signingAfB6vR4HU2R1C3paCJfl8rs_45Z2SowxCE9WxhlnZqvwMeta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/signin.vue?macro=true";
import { default as indexN8nkQGUhaYiSoGuY_YFQPpbpjBSWq4tEgsQO__q_45FTIMeta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/checkout/index.vue?macro=true";
import { default as _91_46_46_46slug_93RxTt_1fn6a2LThQ0Ap0PwIXGucQl0rYA6o9lWBHtZVwMeta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93n4vEdbY7XqGNwlBjUUWPD8HY3VN1lAJsGUV1Eckum14Meta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/salestool/[...slug].vue?macro=true";
import { default as indexEDF0JTlid_45UixiaPIDedWBKz924WrUTb6jEQQpL_45z9AMeta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/signup/index.vue?macro=true";
import { default as successQGV5WdNOr00_iJBBzjOpImGI_YGpMQCrM33pN0BbZY4Meta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/signup/success.vue?macro=true";
import { default as welcomeQQUYVFLAcoUBG0nRWOH0aF_45y__45Fn1GQu_zblSPzEslsMeta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/signup/welcome.vue?macro=true";
import { default as _91cartId_933CQwqozEHt4pIruoq5WdDUHnH0XyyGQH_45gSQUJn8RcEMeta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/checkout/[result]/[cartId].vue?macro=true";
import { default as _91basketId_93DprHQj_45id9S8tj7sj02g4aDCbaOyO_45x2cDIEOqpPHBcMeta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/checkout/pointshop/[basketId].vue?macro=true";
import { default as _91token_93p8GDrMqrOATrug_3zOxov6v0Id7_IWAI5OP8kNt7BiEMeta } from "/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/resetpassword/[email]/[token].vue?macro=true";
export default [
  {
    name: "test",
    path: "/test",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/test.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexeH_45knvsPxuzKCtuhxbzmq3A52gxj9sNHQK_MhXjK724Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "barcode",
    path: "/barcode",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/barcode.vue")
  },
  {
    name: "barcodelookup",
    path: "/barcodelookup",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/barcodelookup.vue")
  },
  {
    name: "tailwindfixes",
    path: "/tailwindfixes",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/tailwindfixes.vue")
  },
  {
    name: "lang-search",
    path: "/:lang?/search",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/search.vue")
  },
  {
    name: "lang-slug",
    path: "/:lang?/:slug(.*)*",
    meta: _91_46_46_46slug_93s9dV7W0HCoMclY1pk8hm_MupxaEggIy7hpVL4anbzFoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/[...slug].vue")
  },
  {
    name: "formValidationTemplate",
    path: "/formValidationTemplate",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/formValidationTemplate.vue")
  },
  {
    name: "lang-account-invite",
    path: "/:lang?/account/invite",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/invite.vue")
  },
  {
    name: "lang-account-signin",
    path: "/:lang?/account/signin",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/signin.vue")
  },
  {
    name: "lang-checkout",
    path: "/:lang?/checkout",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/checkout/index.vue")
  },
  {
    name: "lang-account-slug",
    path: "/:lang?/account/:slug(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/[...slug].vue")
  },
  {
    name: "lang-salestool-slug",
    path: "/:lang?/salestool/:slug(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/salestool/[...slug].vue")
  },
  {
    name: "lang-account-signup",
    path: "/:lang?/account/signup",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/signup/index.vue")
  },
  {
    name: "lang-account-signup-success",
    path: "/:lang?/account/signup/success",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/signup/success.vue")
  },
  {
    name: "lang-account-signup-welcome",
    path: "/:lang?/account/signup/welcome",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/signup/welcome.vue")
  },
  {
    name: "lang-checkout-result-cartId",
    path: "/:lang?/checkout/:result()/:cartId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/checkout/[result]/[cartId].vue")
  },
  {
    name: "lang-checkout-pointshop-basketId",
    path: "/:lang?/checkout/pointshop/:basketId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/checkout/pointshop/[basketId].vue")
  },
  {
    name: "lang-account-resetpassword-email-token",
    path: "/:lang?/account/resetpassword/:email()/:token()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[[lang]]/account/resetpassword/[email]/[token].vue")
  }
]